// src/services/tenant.service.js

class TenantService {
  constructor() {
    this.currentTenant = null;
    this.mainDomain = process.env.REACT_APP_MAIN_DOMAIN || 'interestng.com';
  }

  getCurrentTenant() {
    if (this.currentTenant) {
      return this.currentTenant;
    }

    const hostname = window.location.hostname;
    
    // Special handling for localhost
    if (hostname.includes('localhost')) {
      const parts = hostname.split('.');
      if (parts.length === 2 && parts[0] !== 'localhost') {
        // Format: tenant.localhost
        this.currentTenant = {
          type: 'subdomain',
          domain: hostname,
          subdomain: parts[0]
        };
      } else {
        // Plain localhost
        this.currentTenant = {
          type: 'main',
          domain: hostname,
          subdomain: null
        };
      }
    } else {
      const subdomain = this.extractSubdomain(hostname);
      
      // Check if it's a custom domain
      if (!hostname.includes(this.mainDomain)) {
        this.currentTenant = {
          type: 'custom',
          domain: hostname,
          subdomain: null
        };
      } else if (subdomain && subdomain !== 'www' && subdomain !== 'admin') {
        // It's a subdomain-based tenant
        this.currentTenant = {
          type: 'subdomain',
          domain: hostname,
          subdomain: subdomain
        };
      } else if (subdomain === 'admin') {
        // Super admin domain
        this.currentTenant = {
          type: 'admin',
          domain: hostname,
          subdomain: 'admin'
        };
      } else {
        // Main domain without subdomain
        this.currentTenant = {
          type: 'main',
          domain: hostname,
          subdomain: null
        };
      }
    }

    return this.currentTenant;
  }

  extractSubdomain(hostname) {
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      // Remove the main domain parts (e.g., 'bureaubox.com')
      const mainDomainParts = this.mainDomain.split('.').length;
      if (parts.length > mainDomainParts) {
        return parts[0];
      }
    }
    return null;
  }

  isAdminDomain() {
    const tenant = this.getCurrentTenant();
    return tenant.type === 'admin';
  }

  isTenantDomain() {
    const tenant = this.getCurrentTenant();
    return tenant.type === 'subdomain' || tenant.type === 'custom';
  }

  getTenantIdentifier() {
    const tenant = this.getCurrentTenant();
    if (tenant.type === 'subdomain') {
      return tenant.subdomain;
    } else if (tenant.type === 'custom') {
      return tenant.domain;
    }
    return null;
  }

  // Reset tenant (useful for testing or when switching tenants)
  resetTenant() {
    this.currentTenant = null;
  }
}

export default new TenantService();